define.alias("shared/components/shared/ui/group-avatar", "media/components/shared/ui/group-avatar");